import axios from 'axios';

let cachedAuthData = null;
let authPromise = null; // Prevent multiple simultaneous calls

export async function getHoursManagerAuth(forceRefresh = false) {
  // If we want to force refresh, clear cache
  if (forceRefresh) {
    cachedAuthData = null;
    authPromise = null;
  }

  // Return cached data if available
  if (cachedAuthData) {
    return cachedAuthData;
  }

  // If there's already a pending request, return that promise
  // This prevents multiple components from making duplicate calls
  if (authPromise) {
    return authPromise;
  }

  // Create the promise and store it
  authPromise = fetchAuthData();
  
  try {
    const data = await authPromise;
    return data;
  } finally {
    authPromise = null; // Clear the promise after it resolves
  }
}

async function fetchAuthData() {
  try {
    const response = await axios.get('./remote-apis/hours-role.php');
    // window.console.log('Hours role response:', response.data);
    if (response.data.success) {
      cachedAuthData = {
        isAdmin: response.data.role.isAdmin,
        allDepartmentAccess: response.data.role.allDepartmentAccess,
        userDepartments: response.data.role.userDepartments,
        // username: response.data.username,
        // email: response.data.email
      };
      return cachedAuthData;
    } else {
      throw new Error(response.data.error || 'Authentication failed');
    }
  } catch (error) {
    window.console.error('Error fetching auth data:', error);
    throw error;
  }
}

// Helper function to check if user has access to a specific department
export function canAccessDepartment(authData, departmentCode) {
  // Admin can access everything
  if (authData.isAdmin) {
    return true;
  }

  // All department access can access everything
  if (authData.allDepartmentAccess) {
    return true;
  }

  // Check if department code is in user's department list
  if (authData.userDepartments && Array.isArray(authData.userDepartments)) {
    return authData.userDepartments.some(
      dept => dept.department_code === departmentCode
    );
  }

  return false;
}

// Optional: Clear cache manually
export function clearAuthCache() {
  cachedAuthData = null;
  authPromise = null;
}

// Optional: Check if we have cached data without fetching
export function hasCachedAuth() {
  return cachedAuthData !== null;
}